import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector:
    '[pgPrefixIcon], pg-prefix-icon, [gritPrefixIcon], grit-prefix-icon',
  exportAs: 'pgPrefixIcon, gritPrefixIcon',
})
export class PgPrefixIconDirective {
  @HostBinding('class.grit-prefix-icon')
  @HostBinding('class.pg-prefix-icon')
  _classPrefixIcon = true;

  constructor() {}
}
